exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".division {\n  border: none;\n  margin-top: 10px;\n  width: auto;\n}\n.button-redirection {\n  height: auto;\n  padding: 10px 10px 10px 10px;\n  margin-left: 35%;\n  margin-right: 35%;\n  background-color: #90CC1B;\n  border: none;\n  border-radius: 3px;\n}\n.redirection {\n  color: #fff;\n  font-size: 14px;\n  font-weight: bold;\n  text-align: center;\n}\n.redirection:hover {\n  color: #fff;\n}", ""]);

// exports
